'use client'
import { Providers } from '@/context/providers'
import { Sourcepoint } from '@/services/components/strategies/privacy/Sourcepoint'
import { GlobalInitializer } from '@/services/sourcepoint/GlobalInitializer'
import { AdAlliance } from '@/lib/ads/AdAlliance/AdAlliance'
import { Outbrain } from '@/lib/ads/Outbrain/Outbrain'
import { AdDefend } from '@/lib/ads/AdDefend/AdDefend'
import TrackingPixel from '@/services/tracking/components/TrackingPixel'
import { ClientPageTracking } from '@/services/tracking/components/ClientPageTracking'
import AdDensity from '@/lib/ads/AdDensity/AdDensity'

export default function ClientIslands(props: any) {
  return (
    <Providers>
      <Sourcepoint />
      <AdAlliance context={props.ctx} />
      <Outbrain />
      <AdDefend />
      <GlobalInitializer />
      <TrackingPixel />
      <ClientPageTracking isRoot={props.isRoot} dv={props.dv} />
      <AdDensity />
    </Providers>
  )
}
